import {IObjectStyle} from "./types";

export enum MCStyleVariable {
  MainThemeColor = '--siw-mc-main-theme-color'
}

export const WidgetStyle = {
  matchCenter: MCStyleVariable
}

export function setStyleVariable(styleVariable: string, value: string, widgetStyle: IObjectStyle[]): IObjectStyle[] {
  let styleIndex = widgetStyle.findIndex((item) => {
    return item.type === styleVariable;
  });
  if (styleIndex)
    widgetStyle[styleIndex].value = value;

  return widgetStyle;
}
